export default __webpack_public_path__ + "static/media/letsikringafbarnveddoed.480d8447.jpg";